import axiosInstance from './axios';

export const sitefGetUrl = async (
  sitefConfigId: string,
  amount: string,
  orderId: number,
  responseUrl: string,
): Promise<string | null> => {
  try {
    const { data: url } = await axiosInstance({
      method: 'post',
      url: `payments/sitef/get-url`,
      data: {
        sitefConfigId,
        amount,
        orderId,
        responseUrl,
      },
    });
    return url;
  } catch (error) {
    console.log(error);
    return null;
  }
};
